import { alpha, Button, styled } from '@/shared/ui/mui';
/**
 * OutlineButton - A button with purple outline and transparent background
 *
 * Features:
 * - Purple border (primary theme color)
 * - Hover animation with background tint and lift effect
 * - Consistent with brand identity
 * - Great for secondary actions
 *
 * Usage:
 * ```tsx
 * <OutlineButton onClick={handleClick}>
 *   Learn More
 * </OutlineButton>
 * ```
 */
export const OutlineButton = styled(Button)(({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  padding: '10px 24px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '1rem',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    borderColor: theme.palette.primary.main,
    transform: 'translateY(-2px)',
  },
  '&:disabled': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    opacity: 0.5,
  },
}));
